




















import { Component } from '@niknevis/vue-modules'
import { mixins } from 'vue-class-component'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import { InjectReactive } from 'vue-property-decorator'
import { ContentCampaignCollectionType } from '@/modules/content-campaign/models/content-campaign-collection.model'
import ContentCampaignItemsCountByStatus
  from '@/modules/content-campaign/components/shared/ContentCampaignItemsCountByStatus.vue'
import AdminContentCampaignActions
  from '@/modules/content-campaign/components/admin/table/AdminContentCampaignActions.vue'
import { AdminContentCampaignRoute } from '@/modules/content-campaign/routes/admin-content-campaign.route'
import CampaignStatusView from '@/modules/base-campaign/components/shared/CampaignStatusView.vue'

@Component({
  components: {
    TextEllipsis,
    TesTr,
    DateTooltipped
  }
})
export default class AdminContentCampaignCollectionRow extends mixins<TesTableRow>(TesTableRow) {
  constructor(
    protected readonly routes: AdminContentCampaignRoute
  ) {
    super()
  }

  @InjectReactive()
  contentCampaigns!: ContentCampaignCollectionType

  protected columnComponents = {
    items_count: {
      component: ContentCampaignItemsCountByStatus,
      handler: (value, row) => ({
        items_count: value,
        total_counts: row.total_items_count
      })
    },
    status: {
      component: CampaignStatusView,
      handler: (value, row, contentCampaigns) => ({
        status: value,
        statuses: contentCampaigns.statuses
      })
    },
    user: {
      component: AdminUserInfoButton,
      handler: (value) => ({
        basicUser: value
      })
    },
    running_at: {
      component: DateTooltipped,
      handler: (value) => ({
        isoDate: value
      })
    },
    actions: {
      component: AdminContentCampaignActions,
      handler: (value, row) => ({
        id: row.id
      })
    }
  }

  contentCampaignShowUrl(id) {
    return this.routes.show(id)
  }
}
